import type { ClipboardEvent } from 'react'
import React from 'react'

import { Button, Input, useMediaQueryContext } from '@fourthwall/components'
import { useFormik } from '@fourthwall/utils/dist/formik'

import type { FormValues } from '../../NewDomain.types'
import { normalizeDomain } from '../../utils/normalizeDomain'
import * as S from './DomainForm.styled'
import { validationSchema } from './consts'

type DomainFormProps = {
  isLoading: boolean
  onSubmit: (values: FormValues, onError: (message: string) => {}) => void
}

export const DomainForm = ({ isLoading, onSubmit }: DomainFormProps) => {
  const media = useMediaQueryContext()
  const handleSubmit = (values: FormValues, { setErrors }: any) => {
    onSubmit(values, (message) => setErrors({ domain: message }))
  }

  const formik = useFormik<FormValues>({
    initialValues: {
      domain: '',
    },
    validationSchema,
    onSubmit: handleSubmit,
  })

  const handleDomainPaste = (event: ClipboardEvent<HTMLInputElement>) => {
    event.preventDefault()
    formik.setFieldValue('domain', normalizeDomain(event.clipboardData.getData('Text')))
  }

  return (
    <form onSubmit={formik.handleSubmit}>
      <Input
        placeholder="yourwebsite.com or shop.yourwebsite.com"
        suggestion="Enter the URL of the domain you want to connect (e.g., yourwebsite.com or shop.yourwebsite.com)"
        disabled={isLoading}
        {...formik.getFieldProps('domain')}
        onPaste={handleDomainPaste}
      />
      <S.ButtonContainer>
        <Button
          label="Connect domain"
          appearance="primary"
          type="submit"
          fullWidth={!media.tablet}
          loading={isLoading}
          disabled={!formik.dirty || !formik.isValid}
        />
      </S.ButtonContainer>
    </form>
  )
}
